module.exports = __webpack_public_path__ + "img/delete.e7696a40.svg";